import styled from "@emotion/styled";
import { FC } from "react";
import { useSelector } from "react-redux";

import {
  DesignToken,
  Display,
  Link,
  PromoBannerV2,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import providersImage from "assets/img/settings/forwarding-banner-providers.png";
import Flex from "components/layout/Flex";
import { HelpCenter } from "constants/help-center";
import { openInNewCard } from "helpers/routing";
import { selectDefaultMailboxUsed } from "store/entities/license";
import { withVar } from "themes/helpers";

import { trackLearnMoreClicked } from "./analytics";

interface IProps {
  onReadForwardingInstructions: () => void;
}

export const ForwardingInfo: FC<IProps> = ({ onReadForwardingInstructions }) => {
  const defaultMailboxUsed = useSelector(selectDefaultMailboxUsed);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const trackLearnMore = () => trackLearnMoreClicked(defaultMailboxUsed);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleReadForwardingInstructions = () => {
    onReadForwardingInstructions();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleLearnMore = () => {
    trackLearnMore();
    openInNewCard(HelpCenter.EMAIL_FORWARDING);
  };

  if (defaultMailboxUsed) {
    return (
      <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>
        Forward a copy of your messages from your current email address to HelpDesk.{" "}
        <Link href={HelpCenter.EMAIL_FORWARDING} bold={false} target="_blank" onClick={trackLearnMore}>
          Learn more
        </Link>
      </Text>
    );
  }
  return (
    <PromoBannerV2
      primaryButton={{
        label: "Read forwarding instructions",
        handleClick: handleReadForwardingInstructions,
      }}
      secondaryButton={{
        label: "Learn more",
        handleClick: handleLearnMore,
      }}
      css={{
        background: withVar(DesignToken.SurfaceGradient11),
      }}
      additionalContent={<ProvidersImage src={providersImage} />}
    >
      <Flex column gap={withVar(SpacingToken.Spacing2)}>
        <Display size="md">Set up forwarding from your email address</Display>
        <Text>Forward a copy of your messages from your current email address to HelpDesk.</Text>
      </Flex>
    </PromoBannerV2>
  );
};

const ProvidersImage = styled.img`
  max-height: 128px;
`;
